import { Stack } from "@mui/material";
import { useGenericModal } from "src/components/reusable/components/GenericModal";
import { IconCircle } from "../redeemGift/IconCircle";
import { SSText } from "src/components/base/components/SSText";
import { useSSTheme } from "src/components/reusable/hooks/useSSTheme";
import { throttleTime } from "src/utils/utils";
import { TCheckoutApiResponse } from "src/shared/types/api.types";
import { useTeamConfig } from "src/components/reusable/components/TeamConfigProvider";

export function useSendGiftSuccessModal() {
  const theme = useSSTheme();
  const genericModal = useGenericModal();
  const teamConfig = useTeamConfig();
  const SEND_GIFT_SUCCESS_MODAL = teamConfig?.CHECKOUT_PAGE_SETTINGS?.SEND_GIFT_SUCCESS_MODAL; // prettier-ignore

  const findLanguage = (checkoutRes: TCheckoutApiResponse) => {
    let TITLE, DESCRIPTION;
    if (checkoutRes.sendDate) {
      TITLE = SEND_GIFT_SUCCESS_MODAL?.SEND_LATER_TITLE;
      DESCRIPTION = SEND_GIFT_SUCCESS_MODAL?.SEND_LATER_DESCRIPTION;
    } else {
      TITLE = SEND_GIFT_SUCCESS_MODAL?.SEND_NOW_TITLE;
      DESCRIPTION = SEND_GIFT_SUCCESS_MODAL?.SEND_NOW_DESCRIPTION;
    }
    return { TITLE, DESCRIPTION };
  };

  const close = async (ev?: any) => {
    genericModal.set({ isOpen: false });
    throttleTime(500, () => {
      genericModal.reset();
    });
  };

  const open = (checkoutRes: TCheckoutApiResponse) => {
    const { TITLE, DESCRIPTION } = findLanguage(checkoutRes);

    genericModal.set({
      isOpen: true,
      title: "Gift Confirmed!",
      hideTitleIcon: true,

      description: (
        <Stack spacing={2} alignItems="center" textAlign="center">
          <IconCircle />
          <SSText variant="h4" lineHeight={1.3} fontWeight={700}>
            {TITLE || "Gift Sent Successfully"}
          </SSText>
          <SSText
            variant="body"
            fontSize={`1.1rem`}
            lineHeight={1.4}
            color={theme.mui.palette.grey[700]}
          >
            {DESCRIPTION ||
              "Your gift purchase was successful. The recipient will soon receive an email with their gift and your message."}
          </SSText>
        </Stack>
      ),
      isCloseButtonHidden: true,
      confirmButtonText: "Close",
      onClickConfirm: close,
      closeIconProps: { onClick: close },
      confirmButtonProps: { size: "large" },
    });
  };

  return {
    open,
    close,
  };
}
